<template src="./index.html">
</template>
<script>
export default {
  name: 'ConfigurationCenter',
  components: {
  },
  data: function() {
    return {
		value:'',
		
		meaudatas:[],
		meaudata:[
			
		]
    };
  },
  created() {
  },
  mounted() {
	 //  var meau = [
	 //  	{
		// icon:"meauicon5",
	 //  	resName: '组织机构',
	 //  	children:[
	 //  		{
	 //  		resName: '实体管理',
	 //  		resCode: 'EntityManagement',	
	 //  		},
		// 	{
		// 	resName: '用户实体配置',
		// 	resCode: 'UserEntityConfiguration',	
		// 	},
	 //  		{
	 //  		resName: '用户管理',
	 //  		resCode: 'UserManagement',	
	 //  		},
		// 	{
		// 	resName: '权限管理',
		// 	resCode: 'PermissionManagement',	
		// 	},
		// 	{
		// 	resName: '定时任务实例管理',
		// 	resCode: 'ScheduledTasks',	
		// 	}
	 //  	]
	 //  	},
	 //  	{
		// 	icon:"meauicon6",
	 //  	resName: '数据处理',
	 //  	children:[
		// 	{
		// 	resName: '账套管理',
		// 	resCode: 'ACSetManagement',	
		// 	},
		// 	{
		// 	resName: '财年设置',
		// 	resCode: 'FiscalYearSetup',	
		// 	},
		// 	{
		// 	resName: '币种设置',
		// 	resCode: 'CurrencySettings',	
		// 	},
	 //  		{
	 //  		resName: '中方科目',
	 //  		resCode: 'ChineseSubjects',	
	 //  		},
		// 	{
		// 	resName: '科目映射',
		// 	resCode: 'AccountMapping',	
		// 	},
		// 	{
		// 	resName: '分析代码管理',
		// 	resCode: 'AnalysisCode',	
		// 	},
		// 	{
		// 	resName: '分析字段名称',
		// 	resCode: 'AnalysisFieldName',	
		// 	},
	 //  		{
	 //  		resName: '模板文件管理',
	 //  		resCode: 'TemplateFile',	
	 //  		},	
	 //  	]
	 //  	},
	  	
	 //  ]
  	// this.meaudata = JSON.parse(JSON.stringify(meau))
	this.meaudata =JSON.parse(localStorage.getItem('MenuPermission'))[JSON.parse(localStorage.getItem('MenuPermission')).length - 1].children;
	this.meaudatas=this.meaudata
  },
  methods: {
	  inputx(e){
		  this.meaudatas=[]
		for(let a = 0 ; a < this.meaudata.length ;a++){
			this.meaudatas.push({
				icon:this.meaudata[a].icon,
				resName:this.meaudata[a].resName,
				children:[],
			})
			if(this.meaudata[a].children.length!=0){
				this.meaudata[a].children.map((item1,index)=>{
					if(item1.resName.indexOf(e)==0){
						this.meaudatas[a].children.push({
							...item1
						})
					}
				})
			}
		}
		for(let a = 0 ; a < this.meaudatas.length ;a++){
			if(this.meaudatas[a].children.length==0){
				this.meaudatas.splice(a,1)
				a--
			}
		}
	  },
	  forRoute(route){
		  this.$router.push("/"+route)
	  }
  }
};
</script>


<style scoped lang="less">
 @import url('./index.less');
</style>
